import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const NEW_PAYROLL_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
